import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Rooted in Dubai, built for the world",
    body: "From our home in Dubai, we sit at the crossroads of East and West — giving our clients a genuine gateway to global markets and regional expertise in equal measure.",
  },
  {
    n: "02",
    title: "One house, every discipline",
    body: "Marketing, advertising, hospitality and IT consulting under a single, accountable roof. No hand-offs, no gaps — a seamless experience from first brief to final result.",
  },
  {
    n: "03",
    title: "Precision over noise",
    body: "We measure what matters and pursue outcomes, not vanity metrics. Every engagement is engineered to move a real number for your business.",
  },
];

export const Manifesto = () => (
  <section id="approach" className="px-6 md:px-12 lg:px-24 py-24 md:py-32 lg:py-40 bg-quantum-bg2 border-y border-white/10" data-testid="manifesto-section">
    <Reveal className="mb-20 md:mb-28">
      <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-quantum-gold mb-6">Our approach</p>
      <h2 className="font-serif-q text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight font-light text-quantum-text max-w-4xl">
        A philosophy of quiet excellence.
      </h2>
    </Reveal>

    <div className="space-y-24 md:space-y-32">
      {CHAPTERS.map((c, i) => (
        <Reveal key={c.n} delay={0.05}>
          <div className="relative grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
            <span
              aria-hidden
              className="pointer-events-none select-none absolute -top-16 md:-top-24 -left-2 font-serif-q text-[10rem] md:text-[16rem] leading-none text-white/[0.04] font-light"
            >
              {c.n}
            </span>
            <div className="relative md:col-span-5 z-10">
              <h3 className="font-serif-q text-3xl md:text-4xl lg:text-5xl font-light text-quantum-text leading-tight">
                {c.title}
              </h3>
            </div>
            <div className="relative md:col-span-6 md:col-start-7 z-10">
              <p className="text-lg md:text-xl text-quantum-muted leading-relaxed">{c.body}</p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
